module.exports = __webpack_public_path__ + "img/reset_scale_step_3.aeb4b6e9.gif";